import { prettifyFileExtension } from "tools/file/prettifyFileExtension";
import {
  AttachmentFile,
  RawAttachmentFile,
  UnpackedAttachmentFile,
} from "ts/api/attachmentFile";
import { v4 as uuid } from "uuid";

export const unpackFileAttachment = (
  attachment:
    | Partial<AttachmentFile & { id: string }>
    | Partial<RawAttachmentFile & { id: string }>
): UnpackedAttachmentFile => {
  // `file.name` can be empty, so fall back to `title` to give
  // `prettifyFileExtension` something to parse an extension from.
  const fileName = attachment?.file?.name || attachment?.title || "attachment";
  return {
    extension: prettifyFileExtension({ name: fileName }),
    url: attachment.url || "",
    title: attachment?.title || "",
    ...(attachment?.provider && {
      provider: attachment?.provider,
    }),
    size: attachment?.file?.size || 0,
    id: attachment.id || uuid(),
    // Response uploads carry both (`id` is the `task_response_files` row);
    // everywhere else `id` already IS the file id.
    fileId: attachment.fileId || attachment.id,
    path: "path" in attachment ? attachment.path : "",
  };
};
